<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<LoadingDowloadPDF
			v-if="type === 'loading'"
			:text="'Đang tải xuống file PDF hoá đơn...'"
		/>
		<active-contract
			v-else
			@close="modalIsOpen = false"
			:id="centerId"
			@success="reloadPage"
		></active-contract>
	</DaModalFrame>

	<div class="__report-lesson px-12 md-down:px-4 pb-10">
		<div
			class="__report-lesson__header pt-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl"
			>
				<svg
					class="mr-3 h-6 w-6"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M0.0867744 6.22202C0.440527 4.66346 1.83439 3.5 3.5 3.5H24.5C26.1656 3.5 27.5595 4.66346 27.9132 6.22202L14 14.7245L0.0867744 6.22202ZM0 8.2199V20.651L10.1556 14.4261L0 8.2199ZM11.8325 15.4508L0.335774 22.4978C0.897057 23.6815 2.10294 24.5 3.5 24.5H24.5C25.8971 24.5 27.1029 23.6815 27.6642 22.4978L16.1675 15.4508L14 16.7755L11.8325 15.4508ZM17.8444 14.4261L28 20.651V8.2199L17.8444 14.4261Z"
						fill="#65758B"
					/>
				</svg>

				Gói dịch vụ
			</div>
		</div>
		<div v-if="!isLoading">
			<div class="my-8" v-if="alertShow">
				<div
					class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
				>
					<div class="flex justify-between gap-4">
						<div class="flex items-center gap-4">
							<div>
								<img
									src="@/assets/images/logo/logo.svg"
									alt="luca-logo"
									height="24"
									width="35"
								/>
							</div>
							<div class="pt-1 text-neutral-600 text-sm">
								Gói đăng ký của {{ centerName }} sẽ hết hạn sau
								{{ dayLeft }}
								ngày nữa. Quý thầy cô vui lòng gia hạn gói
								<span
									@click="
										$router.push('/packages/buying-package')
									"
									class="underline text-green-500 font-medium cursor-pointer"
									>tại đây.</span
								>
								để tiếp tục sử dụng Luca Education.
							</div>
						</div>
						<div>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								class="cursor-pointer"
								@click="alertShow = false"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="my-8" v-if="hasNewContract">
				<div
					class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
				>
					<div class="relative">
						<div class="flex items-center gap-4">
							<div>
								<img
									src="@/assets/images/logo/logo.svg"
									alt="luca-logo"
									height="24"
									width="35"
								/>
							</div>
							<div class="pt-1 text-neutral-600 text-sm">
								Gói dịch vụ hiện tại đã kết thúc. Vui lòng
								<span
									@click="modalIsOpen = true"
									class="underline text-green-500 font-medium cursor-pointer"
									>kích hoạt</span
								>
								gói mới đã đăng ký trước đó để tiếp tục sử dụng.
							</div>
						</div>
						<div
							class="top-1 right-2 absolute cursor-pointer"
							@click="hasNewContract = false"
						>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="w-full mb-10">
				<div class="border-b border-neutral-200 md-down:hidden">
					<nav class="-mb-px flex space-x-8 tabs" aria-label="Tabs">
						<div
							v-for="tab in visibleTabsMenu"
							:key="tab.id"
							class="border-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-6 px-1 border-b-2 font-semibold cursor-pointer"
							:class="
								tabSelected.id === tab.id
									? 'text-yellow-700 border-yellow-500'
									: 'text-neutral-500'
							"
							@click="tabSelected.id = tab.id"
						>
							<div class="flex items-center gap-2">
								<div>{{ tab.name }}</div>
							</div>
						</div>
					</nav>
				</div>
				<div class="md:hidden">
					<div class="p-6 bg-white select-tabs">
						<Multiselect
							v-model="tabSelected"
							deselect-label="Đã chọn"
							track-by="id"
							:options="visibleTabsMenu"
							:searchable="true"
							label="nameSearch"
							:allow-empty="false"
							selectLabel=""
						>
							<template #noResult>
								Không tìm thấy kết quả
							</template>
							<template v-slot:option="props">
								<div class="flex flex-nowrap items-center">
									<div>
										{{ props.option.name }}
									</div>
								</div>
							</template>
							<template v-slot:singleLabel="{ option }">
								<div
									class="flex flex-nowrap items-center font-medium text-yellow-700"
								>
									<div>
										{{ option.name }}
									</div>
								</div>
							</template>
						</Multiselect>
					</div>
				</div>
			</div>
			<div v-show="tabSelected.id === 0">
				<div class="bg-white p-6 rounded-lg shadow-sm">
					<div
						class="flex items-center justify-between mb-4 sm-down:flex-col sm-down:items-start"
					>
						<div class="flex items-center gap-2">
							<img
								class="w-6 h-6"
								v-if="Object.keys(active_contract).length > 0"
								src="@/assets/images/icons/invoice.png"
								alt=""
							/>
							<img
								class="w-6 h-6"
								v-else
								src="@/assets/images/icons/invoice_3_fill.png"
								alt=""
							/>
							<div
								class="text-lg font-semibold text-gray-600"
								v-if="active_contract?.invoice_number"
							>
								{{ active_contract?.invoice_number }}
								-
								{{
									active_contract.day_left > 0
										? 'Gói hiện tại'
										: 'Đã kết thúc'
								}}
							</div>
							<div
								class="text-lg font-semibold text-gray-600"
								v-else
							>
								{{ last_expired_contract.invoice_number }}
								- Đã kết thúc
							</div>
						</div>
						<div class="flex items-center gap-2">
							<button
								class="button-p text-center whitespace-nowrap w-fit px-8 btn--ghost"
								@click="
									$router.push(
										'/packages/buying-package?type=student'
									)
								"
								v-if="
									flagCheck() &&
									Object.keys(active_contract).length > 0 &&
									active_contract.day_left > 0
								"
							>
								Đăng ký thêm học sinh
							</button>
							<button
								class="button-p text-center whitespace-nowrap w-max"
								@click="
									$router.push('/packages/buying-package')
								"
								v-if="flagCheck()"
							>
								Đăng ký gói Luca Education
							</button>
						</div>
					</div>
					<div
						class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 text-gray-500"
					>
						<div
							class="p-4 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
						>
							<div>Gói dịch vụ đăng ký</div>
							<div
								class="text-lime-600 mt-2 flex items-center gap-2 text-4xl font-semibold"
								v-if="active_contract.package_tier === 'lite'"
							>
								<img
									src="@/assets/images/icons/package-leaf.svg"
									alt=""
									class="w-8 h-8"
								/>
								<span>Luca Lite</span>
							</div>
							<div
								class="text-amber mt-2 flex items-center gap-2 text-4xl font-semibold"
								v-else-if="
									active_contract.package_tier === 'standard'
								"
							>
								<img
									src="@/assets/images/icons/package-crown.svg"
									alt=""
									class="w-8 h-8"
								/>
								<span>Luca Pro</span>
							</div>
							<div
								v-else
								class="text-4xl font-semibold text-neutral-600 mt-2"
							>
								Demo
							</div>
						</div>
						<div
							class="p-4 md:border-t border-b border-r md-down:border-l border-neutral-200 w-full"
						>
							<div>Tổng số học sinh</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2"
							>
								<span v-if="active_contract.seats">
									{{
										Number(
											active_contract.seats +
												active_contract.bonus_seats
										)
									}}
								</span>
								<span v-else>
									{{
										Number(
											last_expired_contract.seats +
												last_expired_contract.bonus_seats
										)
									}}
								</span>
							</div>
						</div>
						<div
							class="p-4 md:border-t md:border-b md-down:border-l md-down:border-r border-neutral-200 w-full"
						>
							<div>Số học sinh chưa sử dụng</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2"
							>
								<span v-if="active_contract.seats">
									{{
										Number(active_contract.seats) +
										Number(active_contract.bonus_seats) -
										total_student_of_centers
									}}
								</span>
								<span v-else>{{
									Number(last_expired_contract.seats) +
									Number(last_expired_contract.bonus_seats) -
									total_student_of_centers
								}}</span>
							</div>
						</div>
						<div
							class="p-4 border lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none"
						>
							<div>Kết thúc sau</div>
							<div
								class="text-4xl font-bold mt-2"
								:class="
									active_contract.day_left > 0
										? 'text-neutral-600'
										: 'text-sienna-600'
								"
							>
								{{ active_contract.day_left || 0 }} ngày
							</div>
						</div>
					</div>
					<div class="grid grid-cols-3 mt-6 gap-4">
						<div>
							<div class="font-semibold text-neutral-400">
								Thời hạn đăng ký
							</div>
							<div
								class="text-neutral-900 mt-2"
								v-if="active_contract.package"
							>
								{{ active_contract.package }}
							</div>
							<div class="text-neutral-900 mt-2" v-else>
								{{ last_expired_contract.package }}
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Số học sinh đăng ký
							</div>
							<div
								class="text-neutral-900 mt-2"
								v-if="active_contract.seats"
							>
								{{ active_contract.seats }}
							</div>
							<div class="text-neutral-900 mt-2" v-else>
								{{ last_expired_contract.seats }}
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Số học sinh tặng thêm
							</div>
							<div
								class="text-neutral-900 mt-2"
								v-if="active_contract.bonus_seats"
							>
								{{ active_contract.bonus_seats }}
							</div>
							<div class="text-neutral-900 mt-2" v-else>
								{{ last_expired_contract.bonus_seats || 0 }}
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Luca Xu tặng thêm
							</div>
							<div class="text-neutral-900 mt-2">
								<span v-if="centerState === 'community'"
									>Không giới hạn</span
								>
								<span
									v-else-if="active_contract.bonus_credits"
									>{{ active_contract.bonus_credits }}</span
								>
								<span
									v-else-if="
										last_expired_contract.bonus_credits
									"
									>{{
										last_expired_contract.bonus_credits
									}}</span
								>
								<span v-else>0</span>
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Ngày bắt đầu
							</div>
							<div class="text-neutral-900 mt-2">
								<span v-if="active_contract.start_date">
									{{
										$filters.formatDate2(
											active_contract.start_date
										)
									}}</span
								>
								<span
									v-else-if="last_expired_contract.start_date"
									>{{
										$filters.formatDate2(
											last_expired_contract.start_date
										)
									}}</span
								>
								<span v-else>-</span>
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Ngày kết thúc
							</div>
							<div class="text-neutral-900 mt-2">
								<span v-if="active_contract.end_date">{{
									$filters.formatDate2(
										active_contract.end_date
									)
								}}</span>
								<span
									v-else-if="last_expired_contract.end_date"
									>{{
										$filters.formatDate2(
											last_expired_contract.end_date
										)
									}}</span
								>
								<span v-else>-</span>
							</div>
						</div>
					</div>
				</div>
				<div
					class="bg-white p-6 rounded-lg shadow-sm mt-10"
					v-if="Object.keys(new_contract).length > 0"
				>
					<div
						class="flex items-center justify-between mb-4 sm-down:flex-col sm-down:items-start"
					>
						<div class="flex items-center gap-2">
							<img
								class="w-6 h-6"
								src="@/assets/images/icons/invoice_fill.png"
								alt=""
							/>
							<div class="text-lg font-semibold text-gray-600">
								{{ new_contract?.invoice_number }} - Gói mới
							</div>
						</div>
						<button
							class="button-p text-center whitespace-nowrap w-max"
							@click="modalIsOpen = true"
							v-if="hasNewContract"
						>
							Kích hoạt
						</button>
					</div>
					<div
						class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-gray-500"
					>
						<div
							class="p-4 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
						>
							<div>Gói dịch vụ đăng ký</div>
							<div
								class="text-lime-600 mt-2 flex items-center gap-2 text-4xl font-semibold"
								v-if="new_contract.package_tier === 'lite'"
							>
								<img
									src="@/assets/images/icons/package-leaf.svg"
									alt=""
									class="w-8 h-8"
								/>
								<span>Luca Lite</span>
							</div>
							<div
								class="text-amber mt-2 flex items-center gap-2 text-4xl font-semibold"
								v-else-if="
									new_contract.package_tier === 'standard'
								"
							>
								<img
									src="@/assets/images/icons/package-crown.svg"
									alt=""
									class="w-8 h-8"
								/>
								<span>Luca Pro</span>
							</div>
							<div
								v-else
								class="text-4xl font-semibold text-neutral-600 mt-2"
							>
								Demo
							</div>
						</div>
						<div
							class="p-4 md:border-t border-b border-r md-down:border-l border-neutral-200 w-full"
						>
							<div>Tổng số học sinh</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2"
							>
								<span v-if="new_contract.seats">
									{{
										Number(
											new_contract.seats +
												new_contract.bonus_seats
										)
									}}
								</span>
							</div>
						</div>
						<div
							class="p-4 border lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none"
						>
							<div>Áp dụng sau</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2"
								v-if="active_contract.day_left"
							>
								{{ active_contract.day_left }} ngày
							</div>
							<div v-else>-</div>
						</div>
					</div>
					<div class="grid grid-cols-3 mt-6 gap-4">
						<div>
							<div class="font-semibold text-neutral-400">
								Thời hạn đăng ký
							</div>
							<div class="text-neutral-900 mt-2">
								{{ new_contract.package }}
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Số học sinh đăng ký
							</div>
							<div class="text-neutral-900 mt-2">
								{{ new_contract.seats }}
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Số học sinh tặng thêm
							</div>
							<div class="text-neutral-900 mt-2">
								{{ new_contract.bonus_seats }}
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Luca Xu tặng thêm
							</div>
							<div class="text-neutral-900 mt-2">
								<span v-if="centerState === 'community'"
									>Không giới hạn</span
								>
								<span v-else>{{
									new_contract.bonus_credits || 0
								}}</span>
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Ngày bắt đầu
							</div>
							<div class="text-neutral-900 mt-2">
								<span v-if="new_contract.start_date">
									{{
										$filters.formatDate2(
											new_contract.start_date
										)
									}}</span
								>
							</div>
						</div>
						<div>
							<div class="font-semibold text-neutral-400">
								Ngày kết thúc
							</div>
							<div class="text-neutral-900 mt-2">
								<span v-if="new_contract.end_date">
									{{
										$filters.formatDate2(
											new_contract.end_date
										)
									}}</span
								>
							</div>
						</div>
					</div>
				</div>
				<div
					class="shadow-sm sm:rounded-2xl overflow-hidden mt-10"
					v-if="number_students_of_orgs.length"
				>
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											scope="col"
											class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
										>
											CƠ SỞ GIÁO DỤC
										</th>
										<th
											scope="col"
											class="px-6 py-6 text-right text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Học sinh đang kích hoạt
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											item, index
										) in number_students_of_orgs"
										:key="item.id"
										:class="
											index % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="px-6 py-6 whitespace-nowrap text-neutral-700"
										>
											<div>
												{{ item?.org_name }}
											</div>
										</td>
										<td
											class="px-6 py-6 whitespace-nowrap text-neutral-700 text-right"
										>
											<div>
												{{ item?.number_of_students }}
												học sinh
											</div>
										</td>
									</tr>
									<tr class="bg-neutral-50 text-neutral-700">
										<td
											class="px-6 py-6 whitespace-nowrap text-neutral-700 uppercase font-semibold text-sm"
										>
											<div>
												Tổng số học sinh đã sử dụng
											</div>
										</td>
										<td
											class="px-6 py-6 whitespace-nowrap text-neutral-700 text-right uppercase font-semibold text-sm"
										>
											<div>
												{{ total_student_of_centers }}
												học sinh
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div v-if="tabSelected.id === 1">
				<div class="bg-white rounded-lg shadow-sm text-gray-500 mb-8">
					<div class="p-6">
						<div
							class="flex items-center justify-between font-semibold mb-4 sm-down:flex-col sm-down:items-start"
						>
							<div class="text-color text-lg">
								Thông tin gói Luca Xu
							</div>
							<div
								@click="$router.push('/packages/buying-coin')"
								class="flex items-center text-neutral-700 text-sm font-semibold py-3 px-4 buy-more lg-down:ml-auto cursor-pointer"
							>
								Mua thêm Luca Xu
							</div>
						</div>
						<div class="grid grid-cols-1 md:grid-cols-2 mb-4">
							<div
								class="p-4 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
							>
								<div
									class="flex items-center justify-center text-base text-yellow-600 font-semibold px-4 py-2 w-max money"
								>
									Gói 500.000đ
								</div>
								<div
									class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
								>
									<img
										src="@/assets/images/icons/coin.png"
										alt=""
									/>
									<div>5.000</div>
									<div class="text-base font-normal mt-1">
										(1 Xu giá 100đ)
									</div>
								</div>
							</div>
							<div
								class="p-4 border lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none"
							>
								<div
									class="flex items-center justify-center text-base text-yellow-600 font-semibold px-4 py-2 w-max money"
								>
									Gói 1.000.000đ
								</div>
								<div
									class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
								>
									<img
										src="@/assets/images/icons/coin.png"
										alt=""
									/>
									<div>11.000</div>
									<div class="text-base font-normal mt-1">
										(1 Xu giá 91đ)
									</div>
								</div>
							</div>
						</div>
						<div class="flex items-center gap-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Luca Xu không có thời hạn sử dụng và sẽ được
								chuyển tiếp/cộng dồn sang gói tiếp theo
							</div>
						</div>
					</div>

					<div
						class="line bg-neutral-200 block mx-auto my-2 w-full"
						style="height: 1px"
					></div>
					<div class="p-6">
						<div
							class="flex items-center justify-between font-semibold mb-4 lg-down:flex-col lg-down:items-start"
						>
							<div class="text-color text-lg">
								Tặng Luca Xu khi đăng ký Gói Luca Education
							</div>
							<a
								target="_blank"
								href="https://www.luca.education/luca-ai"
								class="text-sm text-yellow-700"
							>
								Tìm hiểu thêm về Luca AI và Luca Xu
							</a>
						</div>
						<div class="grid grid-cols-1 mb-4">
							<div
								class="p-4 border rounded-lg border-neutral-200 w-full box"
							>
								<div
									class="text-4xl font-bold text-neutral-600 flex items-center gap-2 lg-down:flex-wrap"
								>
									<div>Tặng 20</div>
									<img
										class="w-7 h-7"
										src="@/assets/images/icons/coin.png"
										alt=""
									/>
									<div>/ Học sinh /</div>
									<div>Tháng đăng ký sử dụng</div>
								</div>
								<div class="text-base font-normal mt-1">
									Lượng Luca Xu trung tâm nhận được = Số học
									sinh x Số tháng đăng ký x 20 Luca Xu
								</div>
							</div>
						</div>
						<div class="flex items-center gap-2 mb-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Trung tâm sẽ nhận toàn bộ Luca Xu ngay khi bắt
								đầu gói đăng ký
							</div>
						</div>
						<div class="flex items-center gap-2 mb-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Số lượng Luca Xu được tặng đủ để sử dụng cho 3
								báo cáo tuần + 1 báo cáo tháng/ học sinh. Nếu
								trung tâm muốn trải nghiệm thêm các tính năng AI
								khác, có thể mua thêm Xu khi cần!
							</div>
						</div>
						<div class="flex items-center gap-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Luca Xu không có thời hạn sử dụng và sẽ được
								chuyển tiếp/ cộng dồn sang gói tiếp theo
							</div>
						</div>
					</div>
				</div>
				<div
					class="bg-white rounded-lg shadow-sm text-gray-500"
					v-if="!isLitePackage"
				>
					<div class="p-6">
						<div
							class="flex items-center justify-between font-semibold mb-4 sm-down:flex-col sm-down:items-start"
						>
							<div class="text-color text-lg">
								Thông tin gói dung lượng video
							</div>
							<div
								@click="$router.push('/packages/buying-data')"
								class="flex items-center text-neutral-700 text-sm font-semibold py-3 px-4 buy-more lg-down:ml-auto cursor-pointer"
							>
								Mua thêm dung lượng
							</div>
						</div>
						<div class="grid grid-cols-1 md:grid-cols-3 mb-4">
							<div class="p-4 border border-neutral-200 w-full">
								<div
									class="flex items-center justify-center text-base text-yellow-600 font-semibold px-4 py-2 w-max money"
								>
									Gói 55.000đ
								</div>
								<div
									class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
								>
									200 MB
								</div>
							</div>
							<div class="p-4 border border-neutral-200 w-full">
								<div
									class="flex items-center justify-center text-base text-yellow-600 font-semibold px-4 py-2 w-max money"
								>
									Gói 110.000đ
								</div>
								<div
									class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
								>
									500 MB
								</div>
							</div>
							<div class="p-4 border border-neutral-200 w-full">
								<div
									class="flex items-center justify-center text-base text-yellow-600 font-semibold px-4 py-2 w-max money"
								>
									Gói 200.000đ
								</div>
								<div
									class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
								>
									1 GB
								</div>
							</div>
						</div>
						<div class="flex items-center gap-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Dung lượng video mua thêm không có thời hạn sử
								dụng và sẽ được chuyển tiếp/ cộng dồn sang gói
								tiếp theo
							</div>
						</div>
					</div>

					<div
						class="line bg-neutral-200 block mx-auto my-2 w-full"
						style="height: 1px"
					></div>
					<div class="p-6">
						<div
							class="flex items-center justify-between font-semibold mb-4 lg-down:flex-col lg-down:items-start"
						>
							<div class="text-color text-lg">
								Tặng dung lượng video khi đăng ký Gói Luca
								Education
							</div>
							<a
								target="_blank"
								href="https://wiki.luca.education/web-danh-cho-tri-lieu-vien/quan-ly-co-so/kho-video"
								class="text-sm text-yellow-700"
							>
								Tìm hiểu thêm về dung lượng video
							</a>
						</div>
						<div class="grid grid-cols-1 mb-4">
							<div
								class="p-4 border rounded-lg border-neutral-200 w-full box"
							>
								<div
									class="text-4xl font-bold text-neutral-600"
								>
									Tặng 50 MB / Học sinh / Tháng đăng ký sử
									dụng
								</div>
								<div class="text-base font-normal mt-1">
									Tổng số dung lượng video trung tâm nhận được
									= Số học sinh x Số tháng đăng ký x 50 MB
								</div>
							</div>
						</div>
						<div class="flex items-center gap-2 mb-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Trung tâm được tặng toàn bộ số dung lượng (Số
								học sinh x Số tháng đăng ký x 50 MB) ngay khi
								bắt đầu gói đăng ký
							</div>
						</div>
						<div class="flex items-center gap-2 mb-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Dung lượng video được tặng khi đăng ký Gói Luca
								Education chỉ được dùng trong thời hạn gói đăng
								ký, không cộng dồn sang gói tiếp theo
							</div>
						</div>
						<div class="flex items-center gap-2 mb-2">
							<img src="@/assets/images/icons/tick.png" alt="" />
							<div>
								Trong trường hợp trung tâm có nhu cầu báo cáo
								với nhiều hình ảnh, video hơn thông thường,
								trung tâm có thể mua thêm dung lượng từ Luca
							</div>
						</div>
						<div class="flex items-start gap-2">
							<img
								class="mt-1.5"
								src="@/assets/images/icons/tick.png"
								alt=""
							/>
							<div>
								Luca Education sử dụng hạ tầng của AWS (Amazon
								Web Services) để xử lý video và hình ảnh, giúp
								hiển thị nhanh và ổn định trên mọi thiết bị. Chi
								phí mà Luca chi trả cho AWS nằm ở quá trình xử
								lý dữ liệu khi tải lên, chứ không phải dung
								lượng lưu trữ. Vì vậy,
								<span class="font-semibold"
									>việc xoá hình ảnh hoặc video sau khi tải
									lên không giúp giải phóng dung lượng</span
								>
								hoặc giảm chi phí sử dụng
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="tabSelected.id === 2">
				<Media />
			</div>
			<div v-if="tabSelected.id === 3">
				<div class="mb-10" v-if="showCoinNoti">
					<div
						class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
					>
						<div class="relative">
							<div class="flex items-center gap-4 pr-8">
								<div>
									<img
										src="@/assets/images/logo/logo.svg"
										alt="luca-logo"
										height="24"
										width="35"
									/>
								</div>
								<div class="text-neutral-600 text-sm">
									Trung tâm đã sử dụng hết Luca Xu. Để đăng ký
									thêm lượt dùng AI trên Luca Education, quý
									thầy cô vui lòng hoàn thiện biểu mẫu đăng ký
									<span
										class="underline text-green-500 font-medium cursor-pointer"
										>tại đây.</span
									>
								</div>
							</div>
							<div
								class="top-1 right-2 absolute cursor-pointer"
								@click="showCoinNoti = false"
							>
								<svg
									width="12"
									height="12"
									viewBox="0 0 12 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
										fill="#E5A42B"
									/>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div
					class="coin-block flex items-center justify-between p-6 mb-10 bg-white"
				>
					<div class="text-color text-lg font-semibold">
						Luca Xu hiện có
					</div>
					<div class="flex items-center gap-2">
						<img src="@/assets/images/icons/coin.png" alt="" />
						<div class="text-4xl font-bold text-neutral-600">
							{{ creditData?.current_credits || 0 }}
						</div>
					</div>
				</div>
				<div class="relative mb-10">
					<div
						class="absolute inset-0 flex items-center"
						aria-hidden="true"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="bg-body px-2 text-neutral-600 font-semibold whitespace-nowrap flex flex-nowrap items-center text-2xl justify-center gap-6"
						>
							<div
								class="cursor-pointer"
								@click="prevDay"
								v-if="date.month > 1 || date.year > 2025"
							>
								<svg
									width="8"
									height="12"
									viewBox="0 0 8 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6.5 1L1.5 6L6.5 11"
										stroke="#48566A"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
							<div v-if="date">Tháng {{ dateTitle }}</div>
							<div
								class="cursor-pointer"
								@click="nextDay"
								v-if="
									date.month < new Date().getMonth() ||
									date.year < new Date().getFullYear()
								"
							>
								<svg
									width="8"
									height="12"
									viewBox="0 0 8 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M1.5 11L6.5 6L1.5 1"
										stroke="#48566A"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div
					class="bg-white p-6 rounded-lg shadow-sm text-gray-500 mb-10"
				>
					<div class="text-color text-lg font-semibold mb-4">
						Tài khoản Luca Xu
					</div>
					<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
						<div
							class="p-4 border lg:rounded-l-lg md:rounded-tl-lg border-neutral-200 w-full md-down:rounded-t md-down:rounded-b-none"
						>
							<div>Số dư đầu tháng</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
							>
								<img
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>
									{{
										creditData?.start_of_month_credits ||
										'-'
									}}
								</div>
							</div>
						</div>
						<div
							class="p-4 md:border-t border-b border-r md-down:border-l border-neutral-200 w-full"
						>
							<div>Đã nhận</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
							>
								<img
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>
									{{ creditData?.received_credits || 0 }}
								</div>
							</div>
						</div>
						<div
							class="p-4 md:border-t md:border-b md-down:border-l md-down:border-r border-neutral-200 w-full"
						>
							<div>Đã dùng</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
							>
								<img
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>
									{{ creditData?.used_credits || 0 }}
								</div>
							</div>
						</div>
						<div
							class="p-4 border lg:rounded-r-lg md:rounded-br-lg border-neutral-200 w-full md-down:rounded-b md-down:rounded-t-none"
						>
							<div>Số dư cuối tháng</div>
							<div
								class="text-4xl font-bold text-neutral-600 mt-2 flex items-center gap-2"
							>
								<img
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>
									{{
										creditData?.end_of_month_credits || '-'
									}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="creditData.received_credits > 0">
					<div class="relative my-4 w-full">
						<div
							class="absolute inset-0 flex items-center"
							aria-hidden="true"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div class="relative flex justify-between">
							<div class="flex items-center gap-2 bg-body pr-4">
								<img
									v-if="showMonthlyCredit"
									@click="showMonthlyCredit = false"
									class="cursor-pointer"
									src="@/assets/images/icons/arrow-up.png"
									alt=""
								/>
								<img
									v-else
									@click="showMonthlyCredit = true"
									class="cursor-pointer"
									src="@/assets/images/icons/arrow-down.png"
									alt=""
								/>
								<div
									class="whitespace-nowrap org-name font-semibold text-xl"
								>
									Hệ thống cơ sở
								</div>
							</div>
							<div
								class="text-neutral-400 text-xs flex items-center gap-1 bg-body pl-4"
							>
								<div class="whitespace-nowrap">ĐÃ NHẬN</div>
								<img
									class="w-4 h-4"
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>{{ creditData.received_credits }}</div>
							</div>
						</div>
					</div>
					<div
						class="shadow-sm sm:rounded-2xl overflow-hidden"
						v-if="showMonthlyCredit"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
											>
												Gói
											</th>
											<th
												scope="col"
												class="px-6 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											>
												Luca Xu Đã Nhận
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												item, index
											) in creditData.received_credit_histories"
											:key="item.id"
											:class="
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700"
										>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												{{ item.name }}
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												<div
													class="flex items-center gap-3"
												>
													<img
														class="w-5 h-5"
														src="@/assets/images/icons/coin.png"
														alt=""
													/>
													<div>
														{{ item?.credits }}
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div
					v-for="org in creditData.student_with_used_credits"
					:key="org.org_id"
				>
					<div class="relative my-4 w-full">
						<div
							class="absolute inset-0 flex items-center"
							aria-hidden="true"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div class="relative flex justify-between">
							<div class="flex items-center gap-2 bg-body pr-4">
								<img
									v-if="org.show"
									@click="org.show = false"
									class="cursor-pointer"
									src="@/assets/images/icons/arrow-up.png"
									alt=""
								/>
								<img
									v-else
									@click="org.show = true"
									class="cursor-pointer"
									src="@/assets/images/icons/arrow-down.png"
									alt=""
								/>
								<div
									class="whitespace-nowrap org-name font-semibold text-xl"
								>
									{{ org.org_name }}
								</div>
							</div>
							<div
								class="text-neutral-400 text-xs flex items-center gap-1 bg-body pl-4"
							>
								<div class="whitespace-nowrap">ĐÃ DÙNG</div>
								<img
									class="w-4 h-4"
									src="@/assets/images/icons/coin.png"
									alt=""
								/>
								<div>{{ org.used_credits }}</div>
							</div>
						</div>
					</div>
					<div
						class="shadow-sm sm:rounded-2xl overflow-hidden"
						v-if="org.show"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
											>
												STT
											</th>
											<th
												scope="col"
												class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
											>
												TÊN HỌC SINH
											</th>
											<th
												scope="col"
												class="px-6 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											>
												Luca Xu Đã Dùng
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												item, index
											) in org.students"
											:key="item.id"
											:class="
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700"
										>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700 w-16 text-center"
											>
												{{ index + 1 }}
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												<div class="flex items-center">
													<div class="relative">
														<img
															v-if="
																item
																	?.profile_photo
																	?.w200
															"
															:src="
																item
																	?.profile_photo
																	?.w200
															"
															alt=""
															class="shadow-sm inline-block h-6 w-6 rounded-full flex-1"
														/>
														<span
															v-else
															:style="{
																background:
																	item
																		?.profile_photo
																		?.default
																		?.color,
															}"
															class="inline-flex items-center justify-center h-6 w-6 rounded-full"
														>
															<span
																class="font-medium leading-none text-white text-xs"
																>{{
																	item
																		?.profile_photo
																		?.default
																		?.initial
																}}</span
															>
														</span>
														<div
															v-if="
																item.state !==
																'active'
															"
															class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 h-6 w-6 rounded-full flex items-center justify-center"
															style="
																background-color: rgba(
																	241,
																	162,
																	103,
																	0.5
																);
															"
														>
															<svg
																v-if="
																	item.state ===
																	'pending'
																"
																width="14"
																height="14"
																viewBox="0 0 14 14"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	fill-rule="evenodd"
																	clip-rule="evenodd"
																	d="M13.4615 7.00011C13.4615 10.5687 10.5686 13.4617 6.99999 13.4617C3.43138 13.4617 0.538452 10.5687 0.538452 7.00011C0.538452 3.4315 3.43138 0.538574 6.99999 0.538574C10.5686 0.538574 13.4615 3.4315 13.4615 7.00011ZM6.99999 3.3655C6.99999 3.14246 6.81918 2.96165 6.59614 2.96165C6.37311 2.96165 6.1923 3.14246 6.1923 3.3655V7.80781C6.1923 7.95273 6.26995 8.08654 6.39578 8.15844L9.2227 9.77383C9.41636 9.88449 9.66305 9.81721 9.7737 9.62355C9.88436 9.4299 9.81708 9.18321 9.62343 9.07255L6.99999 7.57344V3.3655Z"
																	fill="white"
																/>
															</svg>

															<svg
																v-else
																fill="none"
																height="14"
																viewBox="0 0 40 40"
																width="14"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	clip-rule="evenodd"
																	d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
																	fill="#FAF5F1"
																	fill-rule="evenodd"
																/>
															</svg>
														</div>
													</div>
													<div
														class="ml-4 text-orange-600 font-semibold hover:underline"
														style="max-width: 150px"
													>
														{{ item.name }}
													</div>
												</div>
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												<div>
													{{ item?.used_credits }}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="tabSelected.id === 4">
				<div
					class="__report-lesson__container"
					v-if="data && data.length > 0"
				>
					<div class="shadow-sm sm:rounded-2xl overflow-hidden">
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="px-6 py-6 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left"
											>
												NGÀY GIAO DỊCH
											</th>
											<th
												scope="col"
												class="px-6 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											>
												Gói đăng ký
											</th>
											<th
												scope="col"
												class="px-6 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											>
												Sô lượng
											</th>
											<th
												scope="col"
												class="px-6 py-6 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											>
												Trạng thái
											</th>
											<th class="w-48"></th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(item, index) in data"
											:key="item.id"
											:class="
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700"
										>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												<div v-if="item?.apply_date">
													{{
														$filters.formatDate2(
															item?.apply_date
														)
													}}
												</div>
												<div v-else>-</div>
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												<div>
													{{ item?.invoice_number }}
												</div>
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap text-neutral-700"
											>
												<div>
													{{ item?.seats }}
												</div>
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap"
											>
												<div
													v-if="
														item?.state === 'paid'
													"
													class="text-green-500"
												>
													Hoàn thành
												</div>
												<div
													v-else-if="
														item?.state === 'voided'
													"
													class="text-sienna-600 flex items-center gap-2"
												>
													<div>Đã huỷ</div>
													<Popper
														:arrow="true"
														hover
														placement="top"
														class="flex-shrink-0 inline-flex whitespace-pre-wrap cursor-pointer"
													>
														<img
															src="@/assets/images/icons/deactive.png"
															alt=""
															class="w-4 h-4"
														/>
														<template #content>
															<div
																class="text-neutral-600 font-semibold"
																style="
																	max-width: 260px;
																"
															>
																<div
																	class="text-lg"
																>
																	Yêu cầu đăng
																	ký bị từ
																	chối
																</div>
																<div
																	class="text-neutral-700"
																>
																	Lý do:
																	<span
																		class="font-normal"
																		>{{
																			item?.note
																		}}</span
																	>
																</div>
															</div>
														</template>
													</Popper>
												</div>
												<div
													v-else
													class="text-neutral-700"
												>
													Chờ xác nhận
												</div>
											</td>
											<td
												class="px-6 py-6 whitespace-nowrap text-yellow-700"
											>
												<div
													class="flex items-center gap-2 cursor-pointer"
													@click="
														downloadInvoice(item.id)
													"
												>
													<img
														src="@/assets/images/icons/download-fill.png"
														alt=""
														class="w-4 h-4"
													/>
													<div>Tải hoá đơn</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else
					class="w-full h-full flex items-center justify-center flex-col"
				>
					<img
						src="@/assets/images/illustrations/not_found.png"
						alt=""
						height="250"
						width="250"
					/>
					<div
						class="text-neutral-500 text-lg text-center"
						style="max-width: 700px"
					>
						Không có hoá đơn
					</div>
				</div>
			</div>
			<div v-if="tabSelected.id === 5">
				<Affiliate />
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import Loading from '@/components/common/Loading';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import ActiveContract from '@/views/packages/activeContract.vue';
import dayjs from 'dayjs';
import Multiselect from '@suadelabs/vue3-multiselect';
import Media from '@/views/media/Media.vue';
import Affiliate from '@/views/packages/Affiliate.vue';
import LoadingDowloadPDF from '@/views/plansDetail/features/reportTarget/loadingDowloadPDF/loadingDowloadPDF.vue';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { isLitePackage } from '@/helper/packageTier';
import Popper from 'vue3-popper';

export default {
	name: 'Packages',
	components: {
		Loading,
		DaModalFrame,
		ActiveContract,
		Multiselect,
		Media,
		Affiliate,
		LoadingDowloadPDF,
		Popper,
	},
	data() {
		return {
			active_contract: {},
			data: [],
			number_students_of_orgs: [],
			total_student_of_centers: 200,
			tabsMenu: [
				{
					id: 0,
					name: 'Gói Luca Education',
				},
				{
					id: 1,
					name: 'Gói tiện ích',
				},
				{
					id: 2,
					name: 'Quản lý dung lượng',
				},
				{
					id: 3,
					name: 'Quản lý Luca Xu',
				},
				{
					id: 4,
					name: 'Lịch sử giao dịch',
				},
				{
					id: 5,
					name: 'Lan toả Luca',
				},
			],
			tabSelected: {
				id: 0,
				name: 'Gói Luca Education',
			},
			params: {},
			isLoading: true,
			alertShow: false,
			creditData: [],
			date: {
				month: new Date().getMonth(),
				year: new Date().getFullYear(),
			},
			showCoinNoti: false,
			showMonthlyCredit: true,
			new_contract: {},
			type: '',
			modalIsOpen: false,
			last_expired_contract: {},
		};
	},

	created() {
		this.fetchContactDetail();
		if (
			this.dayLeft > 0 &&
			this.dayLeft <= 7 &&
			this.$store.state.profile.is_active_org &&
			!this.$store.state.profile.has_new_contract
		)
			this.alertShow = true;
		if (this.creditData.current_credits === 0) this.showCoinNoti = true;
	},

	computed: {
		isAccounting() {
			return this.$store.state.profile.staff.role === 'accountant';
		},
		centerName() {
			return this.$store.state.profile.current_org.name;
		},
		dayLeft() {
			return this.$store.state.profile.days_left_in_contract;
		},
		hasNewContract() {
			return (
				this.$store.state.profile.has_new_contract &&
				!this.$store.state.profile.is_active_org
			);
		},
		centerId() {
			return this.$store.state.profile.center_id;
		},
		centerState() {
			return this.$store.state.profile.center_state;
		},
		isLitePackage() {
			return isLitePackage(this.$store.state.profile);
		},
		visibleTabsMenu() {
			if (!this.isLitePackage) return this.tabsMenu;
			return this.tabsMenu.filter((tab) => tab.id !== 2);
		},
		datePayload() {
			return dayjs(new Date(this.date.year, this.date.month, 10)).format(
				'YYYY-MM-DD'
			);
		},
		dateTitle() {
			return dayjs(new Date(this.date.year, this.date.month, 1)).format(
				'MM/YYYY'
			);
		},
	},
	watch: {
		date: {
			deep: true,
			handler(value) {
				if (value) {
					this.fetchCredit();
				}
			},
		},
	},
	methods: {
		reloadPage() {
			location.reload();
		},

		async fetchContactDetail() {
			try {
				const {
					data: {
						data,
						number_students_of_orgs,
						active_contract,
						total_student_of_centers,
						new_contract,
						last_expired_contract,
					},
				} = await $api.leader.fetchContact(
					this.params,
					!this.isAccounting
				);
				this.data = data || [];
				this.number_students_of_orgs = number_students_of_orgs || [];
				this.active_contract = active_contract || {};
				this.total_student_of_centers = total_student_of_centers || 0;
				this.new_contract = new_contract || {};
				this.last_expired_contract = last_expired_contract || {};
				await this.fetchCredit();
			} catch (e) {
				console.log(e);
			} finally {
				this.isLoading = false;
			}
		},
		async fetchCredit() {
			try {
				if (this.isLitePackage) return;
				const res = await $api.leader.fetchCredit({
					date: this.datePayload,
				});
				this.creditData = res.data.data;
				for (let org of this.creditData?.student_with_used_credits) {
					org.show = true;
				}
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
					type: 'danger',
				});
			}
		},
		prevDay() {
			const da = dayjs(new Date(this.date.year, this.date.month, 1))
				.subtract(1, 'month')
				.toDate();
			this.date = {
				month: da.getMonth(),
				year: da.getFullYear(),
			};
		},
		nextDay() {
			const da = dayjs(new Date(this.date.year, this.date.month, 1))
				.add(1, 'month')
				.toDate();
			this.date = {
				month: da.getMonth(),
				year: da.getFullYear(),
			};
		},
		async downloadInvoice(id) {
			this.type = 'loading';
			const contractId = id;
			if (!contractId) return;
			const url =
				process.env.VUE_APP_PDF_URL +
				'packages/invoice/' +
				contractId +
				'?token=' +
				localStorage.getItem('tk') +
				'&subdomain=' +
				localStorage.getItem('sub-domain');
			const params = {
				url: url,
				format: 'a2',
				id_render: 'package_invoice_pdf',
			};
			try {
				this.modalIsOpen = true;
				const response = await fetch(
					'https://g4ridpplxi.execute-api.ap-southeast-1.amazonaws.com/',
					{
						method: 'POST',
						body: JSON.stringify(params),
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
						},
					}
				);
				if (!response.ok) {
					window.open(url + '&is_print=true', '_blank');
					this.modalIsOpen = false;
					this.type = '';
					return;
				}
				const data = await response.json();
				if (data.data) {
					this.modalIsOpen = false;
					const linkSource = `data:application/pdf;base64, ${data.data}`;
					const link = document.createElement('a');
					const fileName = 'Hoadon.pdf';
					link.href = linkSource;
					link.download = fileName;
					link.click();
					this.type = '';
				}
			} catch (e) {
				window.open(url + '&is_print=true', '_blank');
				this.modalIsOpen = false;
				this.type = '';
				console.log(e);
			}
		},
		flagCheck() {
			return FLAG_CHECK('CONTRACT_PAYMENT');
		},
	},
};
</script>
<style scoped>
.coin-block {
	border: 1px solid #f0bb4f;
	border-radius: 16px;
}
.buy-more {
	background: #f0bb4f;
	border-radius: 4px;
}
.text-color {
	color: #65758b;
}
.org-name {
	color: #344256;
}
.money {
	background: #fef8ed;
	border-radius: 40px;
}
.box {
	background: #f8fafc;
}
</style>
